import {
	FETCH_PAYROLLS_SUCCESS,
	FETCH_PAYROLL_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
	switch (action.type) {
		case FETCH_PAYROLLS_SUCCESS: {
			return { ...state, index: action.payload };
		}
		case FETCH_PAYROLL_SUCCESS: {
			return { ...state, show: action.payload };
		}
		default:
			return state;
	}
};
